import { pathOr } from 'ramda';
import { getUser } from './getUser';
import { IApplicationState } from '../../types/redux';

export const getUserPhone = (state: IApplicationState) => {
  const user = getUser(state);
  const phone = pathOr(null, ['phones', 0, 'phone'], user);

  return phone ? `+${phone}` : null;
};
